import { parseDateWithTimeZone } from "utils/moment-utils";

export enum PaymentRule {
    NoPayment = 0,
    Prepayment = 1,
    NoShowFee = 2,
    PayAtLocation = 4,
}

export enum PaymentCalculationRule {
    NoPayment = 0,
    PaymentPerGuest = 1,
    PaymentPerBooking = 2,
    PaymentPerResource = 3,
}

export enum PaymentMethod {
    CreditCard = 0,
    Mobile = 6,
    Reepay = 7,
}
export class PaymentEvent {
    id: number;
    type: PaymentEventType;
    transactionDate: IMoment | null;
    payedAmount: number;
    requestedAmount: number;

    constructor(values?: PaymentEvent) {
        this.id = values?.id ?? 0;
        this.type = values?.type ?? PaymentEventType.WebBookingCharge;
        this.transactionDate = parseDateWithTimeZone(values?.transactionDate ?? undefined, true);
        this.payedAmount = values?.payedAmount ?? 0;
        this.requestedAmount = values?.requestedAmount ?? 0;
    }
}

export enum PaymentEventType {
    WebBookingCharge = 6,
    PaymentLinkCharge = 7,
    NoShowCharge = 14,
}

export enum ChargeStatus {
    Unknown = 0,
    CardRegistered = 103,
    InactivatedByUser = 116,
}
